export default "__VITE_ASSET__385bafce__"